import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { decode, addUrlProps, UrlQueryParamTypes } from 'react-url-query';
import { withRouter } from 'react-router-dom';

import { ZeroState } from 'ecs-react-components/dist/index.es';

import { setIsDedicatedWorkflow } from '../../redux/modules/workflow/workflow-action-creator';
import { loadQuestionnaires } from '../../redux/modules/questionnaires/questionnaires-middleware';
import { callWithLoadingIndicator } from '../../redux/modules/loading-indicator/loading-indicator-middleware';

import { DedicatedWorkflowPanel } from '../../components/SystemShared/DedicatedWorkflowPanel';
import LoadingIndicatorContainer from '../LoadingIndicatorContainer';
import { messages } from './PatientKioskQuestionnaires.i18n';
import history from '../../history';
import Questionnaires from './Questionnaires';
import CompleteQuestionnaire from './CompleteQuestionnaire';

class PatientKioskQuestionnaires extends Component {
  constructor() {
    super();
    this.state = {
      loaded: false,
    };
  }
  componentDidUpdate() {
    const { dispatch } = this.props;
    dispatch(setIsDedicatedWorkflow(true));
    if (!this.state.loaded && this.props.patientId) {
      this.setState({ loaded: true });
      this.props.dispatch(
        callWithLoadingIndicator(
          'PatientKioskQuestionnaires',
          () => this.props.dispatch(loadQuestionnaires(this.props.patientId))
        )
      );
    }
  }

  renderQuestionnaires = () => {
    const { assignedQuestionnaires, startIfOnlyOne } = this.props;
    if (!assignedQuestionnaires) {
      return null;
    }
    if (!assignedQuestionnaires.length) {
      return (
        <ZeroState zeroStateMessage={<FormattedMessage { ...messages.page.zeroState } />}
          stateIconCss="ion ion-android-clipboard"
        />
      );
    }
    if (startIfOnlyOne && assignedQuestionnaires.length === 1) {
      const questionnaire = assignedQuestionnaires[0];
      return (
        <div id="home-tabs-navs-contents">
          <CompleteQuestionnaire
            questionnaire={ questionnaire }
            selectedQuestionnaireId={ questionnaire.assignedQuestionnaireId }
            history={history}
          />
        </div>
      );
    }
    return (
      <DedicatedWorkflowPanel headerTitle={messages.page.title} headerClassName="mb-3">
        <Questionnaires
          location={history.location}
          hideHeader
          hideHistory
          currentSelection="Current"
          colCssClass="col"
          passAssignedQsThrough
          assignedQuestionnaires={assignedQuestionnaires}
        />
      </DedicatedWorkflowPanel>
    );
  }

  componentWillUnmount = () => {
    this.props.dispatch(setIsDedicatedWorkflow(false));
  }

  render() {
    return (
      <LoadingIndicatorContainer loadingKey="PatientKioskQuestionnaires">
        { this.renderQuestionnaires() }
      </LoadingIndicatorContainer>
    );
  }
}

PatientKioskQuestionnaires.propTypes = {
  dispatch: PropTypes.func,
  patientId: PropTypes.string,
  assignedQuestionnaires: PropTypes.array,
  startIfOnlyOne: PropTypes.string,
};

const mapStateToProps = (state) => ({
  assignedQuestionnaires: state.questionnaires.assignedQuestionnaires,
  patientId: state.profile.patient.patientId,
});

/**
 * Map from url query params to props.
 */
const mapUrlToProps = (url) => ({
  startIfOnlyOne: decode(UrlQueryParamTypes.string, url.startIfOnlyOne),
});

export default withRouter(connect(mapStateToProps)(addUrlProps({ mapUrlToProps })(PatientKioskQuestionnaires)));
